import { render, staticRenderFns } from "./StorePopupListGlobal.vue?vue&type=template&id=87daf56c&scoped=true&"
import script from "./StorePopupListGlobal.vue?vue&type=script&lang=js&"
export * from "./StorePopupListGlobal.vue?vue&type=script&lang=js&"
import style0 from "./StorePopupListGlobal.vue?vue&type=style&index=0&id=87daf56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87daf56c",
  null
  
)

component.options.__file = "StorePopupListGlobal.vue"
export default component.exports